import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const splunk = defineConnector({
  identifier: "splunk",
  name: "Splunk",
  tagLine: "Security and observability",
  logo,
  protocol: "http",
  tags: ["featured", "it", "security", "observability", "data"],
  defaultUrlPattern: () => "https://.*\\.splunkcloud\\.com/.*",
  auth: (app) => bearerAuth(app.secret.token),
  steps: [
    {
      title: "Get a Splunk authentication token",
      items: [
        {
          kind: "markdown",
          content:
            "In Splunk, navigate to **Settings > Tokens** to create a new authentication token. Make sure to copy the full token value.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "url",
          label: "Splunk base URL",
          required: true,
          placeholder: "https://yourinstance.splunkcloud.com:8089",
          target: { kind: "configuration", field: "baseUrl" },
          helperText:
            "The base URL you use to log in to Splunk Cloud or Enterprise, including https://. Include the management port (default is :8089).",
        },
        {
          kind: "input",
          label: "Authentication token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => `${baseUrl}/services/server/info`,
  },
  publicEnvVars: ({ baseUrl }) => ({
    SPLUNK_URL: baseUrl || "",
  }),
});
